export enum ProxyContext {
  Autentication = 'identity/account/login',
  AutenticationLogout = 'identity/account/logout',
  AuthenticationSendCodeConfirm = 'identity/account/sendCodeRecoverPassword',
  AuthenticationRecoverPassword = 'identity/account/RecoverPassword',
  ValidateLogued = 'identity/account/valid-login',
  GetAllStoreCatalogs = 'catalogs/Catalogs/StoresDHL',
  Users = 'identity/user',
  UserEdit = 'identity/user/edit',
  GetUsers = 'identity/user/list',
  UserDetail = 'identity/user/detail',
  VerifiedAccount = 'identity/account/verify-account',
  UserBlock = 'identity/user/blocked',
  DeleteRol = 'identity/RoleManagement',
  GetSearchRol = 'identity/RoleManagement/getRol',
  GetAllRol = 'identity/RoleManagement/getAllRol',
  GetAllPermiss = 'identity/RoleManagement/getAllPermission',
  GetCreateRol = 'identity/RoleManagement/AddRol',
  GetExport = 'identity/user/export',
  UploadUsersCsv = 'identity/user/create-user-file',
  UsersCatalogs = 'catalogs/catalogs/user-catalogs',
  PolicisPolicy = 'identity/account/privacy-policy',
  WeatherForecast = '',
  GetMenu = 'identity/menu/getMenu',
  SetStoreProcess = 'identity/account/add-store-user',
  SendEmailValidateAccount = 'identity/account/resend-email-welcome',
  GetGuidePacks = 'quotation/quotation/guide-packs',
  AddToCart = 'quotation/quotation',
  UpdateGuideRangeAvailable = 'guides/Guide/upd-guides',
  CreateGuideRangeAvailable = 'guides/Guide/add-guides',
  UpdateGuideRangeBackup = 'guides/guide/upd-guides-backUp',
  CreateGuideRangeBackup = 'guides/guide/add-guides-backUp',
  GetGuideIndividual = 'quotation/quotation/quote-guides',
  GetAllCart = 'quotation/shoppingcart/purchase-detail',
  CancelCart = 'quotation/shoppingcart/cancel-purchase',
  UpdateCart = 'quotation/shoppingcart',
  DeleteGuideAvailable = 'guides/guide/delete-guides',
  RemoveProductFromCart = 'quotation/shoppingcart/delete-product',
  GetrowsODC = 'quotation/purchase/purchased-orders',
  ValidateAccountRetail = 'quotation/shoppingcart/validate-account-retail',
  GetDataBillingCart = 'quotation/purchase/billing-data',
  GenerateODC = 'quotation/purchase/create-order',
  UpdateDataBillingCart = 'billing/billing/create-billing-information',
  GetCatalogsTypePay = 'quotation/purchase/purchase-catalogs',
  GetAllReateDiscount = 'quotation/ratediscount/rate-discount',
  GetAllGuideAvailable = 'guides/guide/get-guides',
  UssasignGuidesForUserByODC = 'guides/Guide/deallocation-guides-subuser',
  GetDetailByUserODCGudies = 'guides/Guide/detail_assigned_guides',
  GetGuidesSubUsers = 'guides/Guide/get-guides-subuser',
  GetEmailAllUsers = 'guides/Guide/get-email-guides',
  GetDetailODC = 'quotation/purchase/detail-odc',
  GetDetailODCTable = 'quotation/purchase/detail-purchased',
  GetDetailUssnagin = 'guides/Guide/get-detail-decollate',
  AssignmentToUserGuides = 'guides/Guide/assing-guides-subuser',
  GetFilesbilling = 'quotation/invoice/documents-invoice',
  GetTotalGuidesAssig = 'guides/Guide/get-total-guides',
  GetTotalGuidesAssigPrint = 'guides/Guide/get-summary-guides',
  GetGuidesBackup = 'guides/guide/get-guides-backup',
  GetPdfGuide = 'guides/Guide/download-pdf-guide',
  GetPriceIndividualRate = 'quotation/quotation/unit-price',
  ValidateProcessGuidesRange = 'guides/guide/validate-guide-process',
  BasePathReateDiscount = 'quotation/ratediscount',
  GetReateDiscountEdit = 'quotation/ratediscount/rate-edit',
  GetReatePackageEdit = 'quotation/package/get-one-package',
  BlockedReatedDiscount = 'quotation/ratediscount/blocked',
  InsertIndividualReatedPrice = 'quotation/ratediscount/create-price',
  GetAllReatePackages = 'quotation/package/package-rate',
  BasePathReatePackage = 'quotation/package',
  BlockedReatePackage = 'quotation/package/blocked',
  GetGuideAdmin = 'guides/Guide/get-guides-admin',
  GetGuideAdminDown = 'guides/Guide/get-guides-admin-download',
  GetAllPrintGuides = 'guides/Guide/get-guides-print',
  AddRemitentesPrint = 'guides/Guide/add-sender-print-guide',
  AddDestinatario = 'guides/Guide/add-adressee-print-guide',
  GetRemitentes = 'guides/Guide/get-sender-print-guide',
  GetDestinatario = 'guides/Guide/get-adressee-print-guide',
  ConfirmPrint = 'guides/Guide/confirm-print-guide',
  GetDetailPrint = 'guides/Guide/get-detalle-product-print-guide',
  ZipeCode = 'guides/Guide/get-citybyzipCode',
  UpdateDestinatario = 'guides/Guide/upd-adressee-print-guide',
  UpdateRemitente = 'guides/Guide/upd-sender-print-guide',
  QuickSearch = 'reports/quicksearch',
  DownloadStaticReport = 'reports/quicksearch/download',
  Templates = 'reports/template',
  GetBaseFields = 'reports/template/get-base-fields',
  DownloadReportByTemplate = 'reports/template/download',
  UploadCoverague = 'guides/Guide/upload-file-toppings',
  DeleteRemitente = 'guides/Guide/delete-sender',
  DeleteDestinatario = 'guides/Guide/delete-adressee',
  GenerateDownloadReport ='guides/Guide/get-file-SAP',
  CashControl = 'cashcontrol/payment',
  GetPaymentsDetail = 'cashcontrol/payment/details',
  DonwloadPaymentsDetailFile = 'cashcontrol/payment/download',
  GetOdcConsult = 'exchequer/exchequer/purchase-orders',
  DownConsultOdc = 'exchequer/exchequer/export-purchase-orders',
  ManualPaymant = 'exchequer/exchequer/create-manual-payment',
  DetailOdcSummary = 'exchequer/exchequer/payment-summary',
  catalogCFDI = 'catalogs/catalogs/uso-cfdi',
  CreateAccountAdmin = 'identity/user/create-customer',
  DetailOdc = 'quotation/purchase/payment-summary',
  GetAllBilling = 'billing/billing/all-directions',
  DeleteBilling = 'billing/billing/delete-billing-information',
  FavoriteBilling = 'billing/billing/update-favorite',
  GetBillingInformation = 'billing/billing/get-billing-information',
  CreateBillingInformation = 'billing/billing/create-billing-information',
  UpdateBillingInformation = 'billing/billing/update-billing-information'
}
